export function normalizeForDiff(text) {
  return String(text ?? '').replace(/\r\n/g, '\n');
}

/** Line-based diff for save review (LCS). */
export function diffLines(oldText, newText) {
  const oldLines = normalizeForDiff(oldText).split('\n');
  const newLines = normalizeForDiff(newText).split('\n');
  const n = oldLines.length;
  const m = newLines.length;

  if (n === 0 && m === 0) return [];

  const dp = Array.from({ length: n + 1 }, () => Array(m + 1).fill(0));

  for (let i = n - 1; i >= 0; i--) {
    for (let j = m - 1; j >= 0; j--) {
      dp[i][j] =
        oldLines[i] === newLines[j]
          ? dp[i + 1][j + 1] + 1
          : Math.max(dp[i + 1][j], dp[i][j + 1]);
    }
  }

  const rows = [];
  let i = 0;
  let j = 0;

  while (i < n && j < m) {
    if (oldLines[i] === newLines[j]) {
      rows.push({ type: 'same', line: oldLines[i] });
      i++;
      j++;
    } else if (dp[i + 1][j] >= dp[i][j + 1]) {
      rows.push({ type: 'remove', line: oldLines[i] });
      i++;
    } else {
      rows.push({ type: 'add', line: newLines[j] });
      j++;
    }
  }

  while (i < n) {
    rows.push({ type: 'remove', line: oldLines[i++] });
  }
  while (j < m) {
    rows.push({ type: 'add', line: newLines[j++] });
  }

  return rows;
}

export function summarizeDiff(rows) {
  let added = 0;
  let removed = 0;
  for (const row of rows) {
    if (row.type === 'add') added++;
    if (row.type === 'remove') removed++;
  }
  return { added, removed };
}

export function serializeEditorContent(content, isJson) {
  if (isJson) {
    if (typeof content === 'string') {
      try {
        return JSON.stringify(JSON.parse(content), null, 2);
      } catch {
        return content;
      }
    }
    return JSON.stringify(content, null, 2);
  }
  return String(content ?? '');
}

/** Semantic JSON equality (ignores key order and formatting). */
export function editorContentEquals(left, right, isJson) {
  if (!isJson) {
    return String(left ?? '') === String(right ?? '');
  }
  try {
    const a = typeof left === 'string' ? JSON.parse(left) : left;
    const b = typeof right === 'string' ? JSON.parse(right) : right;
    return JSON.stringify(a) === JSON.stringify(b);
  } catch {
    return serializeEditorContent(left, true) === serializeEditorContent(right, true);
  }
}
